import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Tengo que comprar juguetes caros?',
  answer: 'No, la guía incluye cómo usar objetos caseros efectivos.'
}, {
  question: '¿Funciona con gatos adultos?',
  answer: 'Sí, el instinto de caza no tiene edad; se puede resetear en cualquier etapa.'
}, {
  question: '¿Qué pasa si mi gato es muy vago?',
  answer: 'Incluimos variantes de juego para gatos con baja motivación.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 sm:py-24 relative" data-id="element-33">
      <div className="mx-auto max-w-3xl px-6 lg:px-8" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12" data-id="element-36">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-38">
              <div className="bg-navy-light/50 border border-white/10 rounded-xl overflow-hidden" data-id="element-39">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-40">
                  <span className="font-bold text-lg text-slate-100" data-id="element-41">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
                </button>
                <AnimatePresence data-id="element-43">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-44">
                      <div className="px-6 pb-5 text-slate-400 font-sans" data-id="element-45">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}